import { apiClient } from './apiClient';

const base = '/api/twilio';

export const twilioService = {
  // Get Twilio configuration
  getConfig: () => apiClient.get(`${base}/config`),

  // Save Twilio configuration
  saveConfig: ({ accountSid, authToken, phoneNumber }) =>
    apiClient.post(`${base}/config`, { accountSid, authToken, phoneNumber }),

  // Delete Twilio configuration
  deleteConfig: () => apiClient.del(`${base}/config`),

  // Make outbound call
  // Optional fields:
  // - agentId: specific agent to use for the call
  // - customerName / customerEmail / customerPhone: passed through to backend for prompt personalization
  makeCall: ({ from, to, agentId, customerName, customerEmail, customerPhone }) =>
    apiClient.post(`${base}/call`, {
      from,
      to,
      agentId,
      customerName,
      customerEmail,
      customerPhone,
    }),

  // Create server-side outbound campaign for true sequential calling
  // contacts: [{ name, email, phone }]
  createCampaign: ({ from, agentId, contacts, name }) =>
    apiClient.post(`${base}/campaigns`, {
      from,
      agentId,
      contacts,
      name,
    }),
};

export default twilioService;
